class FeaturedArticles extends HTMLElement {
  constructor() {
    super();
    this.swiperSelector = this.getAttribute('swiper-selector') || '.swiper-container-featured-articles';
    this.onlyMobile = this.hasAttribute('only-mobile');
    this.breakpoint = parseInt(this.getAttribute('breakpoint') || 768);
  }

  connectedCallback() {
    this.initObserver();
  }

  initObserver() {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          this.initSwiper();
          observer.disconnect(); 
        }
      });
    });
    observer.observe(this);
  }

  initSwiper() {
    const swiperEl = this.querySelector(this.swiperSelector);
    if (!swiperEl) return;

    if (swiperEl.dataset.initialized === 'true') return;
    swiperEl.dataset.initialized = 'true';

    try {
      if (window.swiperManager) {
        new window.swiperManager(this.swiperSelector, {
          onlyMobile: this.onlyMobile,
          breakpoint: this.breakpoint,
          swiper: {
            slidesPerView: 1.1,
            spaceBetween: 12,
            loop: true,
            speed: 800,
            autoplay: {
              delay: 3500,
              disableOnInteraction: false,
              pauseOnMouseEnter: false,
            },
            pagination: { el: '.swiper-pagination', clickable: true },
            navigation: {
              nextEl: '.swiper-button-next',
              prevEl: '.swiper-button-prev',
            },
          },
        });
        console.log('[FeaturedArticles] Swiper initialized');
      } else {
        console.warn('[FeaturedArticles] swiperManager not found on window');
      }
    } catch (err) {
      console.error('[FeaturedArticles] Failed to init Swiper:', err);
    }
  }
}

customElements.define('featured-articles', FeaturedArticles);
